import React, { useState, useEffect, useCallback } from 'react';

function HeroSlider({ language = 'en' }) {
  const slides = [

      {
      id: 2,
      image: '/img/jr7.png',
      content: {
               en: '• Feasibility Studies and Business Plans<br>• Market Research and Investment Analysis',
        ar: '• دراسات الجدوى وخطط الأعمال<br>• أبحاث السوق وتحليل الاستثمار'

      }
    },
    
    {
      id: 0,
      image: '/img/jr5.png',
      content: {
        en: '• Management Consulting Services<br>• Strategic planning and business transformation<br>• Business Development & Market expansion and digital transformation',
        ar: '• خدمات الاستشارات الإدارية<br>• التخطيط الاستراتيجي وتحويل الأعمال<br>• تطوير الأعمال والتوسع في السوق والتحول الرقمي'
      }
    },
    {
      id: 1,
      image: '/img/jr6.png',
      content: {
        en: '• Event Management & Marketing Solutions<br>• Creative campaigns and brand activation',
        ar: '• حلول إدارة الفعاليات والتسويق<br>• الحملات الإبداعية وتنشيط العلامات التجارية'
      }
    },
    {
      id: 2,
      image: '/img/jr7.png',
      content: {
        en: '• Low Current-IT Services Apply And Supply',
        ar: '• خدمات تطبيق وتوريد تيار منخفض-تقنية المعلومات'
      }
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  useEffect(() => {
    if (!autoPlay) return;

    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [autoPlay, nextSlide]);

  return (
    <section className="hero" id="hero">
      <div className="hero-slides">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}
      </div>

      <h1>{language === 'ar' ? 'نحن خبراء' : 'WE ARE EXPERTS'}</h1>

      <div className="hero-texts">
        <div 
          className="hero-text active"
          dangerouslySetInnerHTML={{ 
            __html: slides[currentSlide].content[language] 
          }}
        />
      </div>

      <a href="#services" className="btn">
        {language === 'ar' ? 'اقرأ المزيد' : 'READ MORE'}
      </a>

      <div className="slider-dots">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && goToSlide(index)}
          />
        ))}
      </div>
    </section>
  );
}

export default HeroSlider;